import { BlinqIcon } from './BlinqIcon';

interface BlinqLogoProps {
  className?: string;
}

export const BlinqLogoText: React.FC<React.PropsWithChildren<unknown>> = () => (
  <>
    <path
      d="M408.809 201.357C438.531 201.357 459.447 180.441 459.447 156.222C459.447 135.967 443.815 122.757 432.587 118.573C442.494 113.95 451.741 103.382 451.741 87.9701C451.741 65.9533 433.027 47.239 405.506 47.239H343.859V201.357H408.809ZM368.078 68.155H405.506C418.716 68.155 427.523 76.9617 427.523 89.0709C427.523 101.18 418.716 109.987 405.506 109.987H368.078V68.155ZM368.078 129.802H408.809C424.22 129.802 435.229 140.81 435.229 155.121C435.229 169.432 424.22 180.441 408.809 180.441H368.078V129.802Z"
      fill="black"
    />
    <path d="M510.017 201.357V47.239H488V201.357H510.017Z" fill="black" />
    <path
      d="M554.051 75.8608C560.656 75.8608 567.261 70.3566 567.261 62.6508C567.261 54.9449 560.656 49.4407 554.051 49.4407C547.446 49.4407 540.84 54.9449 540.84 62.6508C540.84 70.3566 547.446 75.8608 554.051 75.8608ZM565.059 201.357V95.6759H543.042V201.357H565.059Z"
      fill="black"
    />
    <path
      d="M619 201.357V144.113C619 126.499 631.109 114.39 647.622 114.39C661.933 114.39 671.84 124.298 671.84 139.71V201.357H693.857V139.71C693.857 111.088 676.244 93.4743 652.025 93.4743C636.173 93.4743 624.064 103.162 619.22 110.647H619V95.6759H596.983V201.357H619Z"
      fill="black"
    />
    <path
      d="M824.9 247.592V95.6759H802.883V110.647H802.663C797.819 103.162 784.609 93.4743 766.555 93.4743C740.135 93.4743 717.018 116.592 717.018 148.516C717.018 180.441 740.135 203.558 766.555 203.558C784.609 203.558 797.819 193.871 802.663 186.385H802.883V247.592H824.9ZM770.959 182.642C753.345 182.642 739.034 168.331 739.034 148.516C739.034 128.701 753.345 114.39 770.959 114.39C788.572 114.39 802.883 128.701 802.883 148.516C802.883 168.331 788.572 182.642 770.959 182.642Z"
      fill="black"
    />
  </>
);

export const BlinqLogo: React.FC<React.PropsWithChildren<BlinqLogoProps>> = ({ className }) => (
  <BlinqIcon className={className}>
    <BlinqLogoText />
  </BlinqIcon>
);
